var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEvents(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.124,
    height: 16.465,
    viewBox: "0 0 20.124 16.465",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "events") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-system-update-alt",
    "data-name": "Icon material-system-update-alt",
    d: "M11.562,17.141l3.659-3.659H12.477V5.25H10.647v8.232H7.9ZM19.794,5.25H14.306V7.07h5.488V19.9H3.329V7.07H8.818V5.25H3.329A1.835,1.835,0,0,0,1.5,7.079V19.885a1.835,1.835,0,0,0,1.829,1.829H19.794a1.835,1.835,0,0,0,1.829-1.829V7.079A1.835,1.835,0,0,0,19.794,5.25Z",
    transform: "translate(-1.5 -5.25)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvents);
export default __webpack_public_path__ + "static/media/events.3e0f0b7969fca48793580f6b79740b0b.svg";
export { ForwardRef as ReactComponent };